/** The names the Entra pickers are registered under, shared by the registration and the validators. */
export const ENTRA_GROUP_PICKER = 'EntraIdGroupPicker';
export const ENTRA_SERVICE_PRINCIPAL_PICKER = 'EntraIdServicePrincipalPicker';
